import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const StyledPopover = styled.span`
  position: relative;

  p {
    font-size: ${themeGet('scale.scaleBase')};
    color: ${themeGet('color.colorWhite')};
  }

  [role='tooltip'][aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.2s linear;
  }

  [role='tooltip'] {
    visibility: hidden;
    position: absolute;
    z-index: ${themeGet('zIndex.zIndex01')};
    top: 0;
    left: 50%;
    transform: translate(-50%, calc(-100% - 15px));
    display: flex;
    justify-content: center;
    width: 300px;
    opacity: 0;
    transition: visibility 0s linear 0.2s, opacity 0.2s linear;
    user-select: none;
  }

  [role='tooltip']::after {
    content: '';
    width: ${themeGet('spacing.spacingSm')};
    height: ${themeGet('spacing.spacingSm')};
    margin-left: -5px;
    background-color: ${themeGet('color.colorGrayBlue100')};
    border-radius: ${themeGet('border.borderSmall')};
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: rotate(45deg);
  }

  [role='tooltip'] > div {
    max-width: 300px;
    background: ${themeGet('color.colorGrayBlue100')};
    color: ${themeGet('color.colorWhite')};
    padding: ${themeGet('scale.scaleUp03')};
    border-radius: ${themeGet('border.borderRadius')};
    position: relative;

    a {
      color: inherit;
    }
  }

  .dismiss {
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    position: absolute;
    right: ${themeGet('spacing.spacingSm')};
    top: ${themeGet('spacing.spacingSm')};
  }
`;

export default StyledPopover;
